import React from 'react'
import styled from 'styled-components'
import { color } from 'styles/colors'
import { IconButton } from '@mui/material'

type Props = {
  freeMessagesRemaining: number | undefined
  showFeedback: boolean
  feedback: 'up' | 'down' | null
  onToggleFeedback: (type: 'up' | 'down') => void
}

const ChatInfoBar = ({ freeMessagesRemaining, showFeedback, feedback, onToggleFeedback }: Props) => {
  return (
    <S.Container>
      {freeMessagesRemaining && (
        <S.MessagesInfo>
          <img src="/img/vector.svg" alt="Info" />
          <S.InfoText $italic>{freeMessagesRemaining} free messages remaining</S.InfoText>
        </S.MessagesInfo>
      )}
      {showFeedback && (
        <S.FeedbackSection>
          <S.InfoText>Was this conversation helpful?</S.InfoText>
          <S.FeedbackIcon $active={feedback === 'up'} onClick={() => onToggleFeedback('up')}>
            <img src="/img/thumbs-up.svg" alt="Like" />
          </S.FeedbackIcon>
          <S.FeedbackIcon $active={feedback === 'down'} onClick={() => onToggleFeedback('down')}>
            <img src="/img/thumbs-down.svg" alt="Dislike" />
          </S.FeedbackIcon>
        </S.FeedbackSection>
      )}
    </S.Container>
  )
}

export default ChatInfoBar

const S = {
  Container: styled.div`
    display: flex;
    justify-content: space-between;
  `,
  MessagesInfo: styled.div`
    display: flex;
    gap: 4px;
    padding: 11px 0;
    align-items: center;
  `,
  InfoText: styled.span<{ $italic?: boolean }>`
    font-size: 12px;
    font-weight: 400;
    font-style: ${({ $italic }) => ($italic ? 'italic' : 'normal')};
    color: ${color('chatbotInfoText')};
  `,
  FeedbackSection: styled.div`
    display: flex;
    align-items: center;
    gap: 2px;
    margin-left: auto;
    padding: 15px 10px;
  `,
  FeedbackIcon: styled(IconButton)<{ $active?: boolean }>`
    width: 17px;
    height: 17px;
    padding: 4px;
    border-radius: 4px;
    background-color: ${({ $active }) => ($active ? color('chatbotFeedbackIconActive') : 'transparent')};
  `
}
